import {
    REQUEST_STATE,

    CORE_GET_ALL_CAR_RESERVE_REQUEST,
    CORE_GET_ALL_CAR_RESERVE_SUCCESS,
    CORE_GET_ALL_CAR_RESERVE_FAILURE,

    CORE_GET_ALL_MY_CAR_RESERVE_REQUEST,
    CORE_GET_ALL_MY_CAR_RESERVE_SUCCESS,
    CORE_GET_ALL_MY_CAR_RESERVE_FAILURE,

    CORE_GET_CAR_RESERVE_BY_ID_REQUEST,
    CORE_GET_CAR_RESERVE_BY_ID_SUCCESS,
    CORE_GET_CAR_RESERVE_BY_ID_FAILURE,

    CORE_GET_CAR_RESERVE_BY_BETWEEN_REQUEST,
    CORE_GET_CAR_RESERVE_BY_BETWEEN_SUCCESS,
    CORE_GET_CAR_RESERVE_BY_BETWEEN_FAILURE,



} from '../types'

const requestState = REQUEST_STATE

export default {
    carReserves: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_CAR_RESERVE_REQUEST:
            case CORE_GET_CAR_RESERVE_BY_BETWEEN_REQUEST:
            case CORE_GET_ALL_MY_CAR_RESERVE_REQUEST:
                return state
            case CORE_GET_ALL_CAR_RESERVE_SUCCESS:
            case CORE_GET_CAR_RESERVE_BY_BETWEEN_SUCCESS:
            case CORE_GET_ALL_MY_CAR_RESERVE_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_GET_ALL_CAR_RESERVE_FAILURE:
            case CORE_GET_CAR_RESERVE_BY_BETWEEN_FAILURE:
            case CORE_GET_ALL_MY_CAR_RESERVE_FAILURE:
                return []
            default:
                return state
        }
    },
    carReserve: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_CAR_RESERVE_BY_ID_REQUEST:
                return state
            case CORE_GET_CAR_RESERVE_BY_ID_SUCCESS:
                if (action.payload) {
                    const { result, datas, data } = action.payload
                    if (result && datas) {
                        return datas
                    } else if (result && data) {
                        return data
                    }
                    else return {}
                } else {
                    return {}
                }
            case CORE_GET_CAR_RESERVE_BY_ID_FAILURE:
                return {}
            default:
                return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/car.js